import { useTranslation } from 'react-i18next';

const defaultAr = "'Cairo', sans-serif"; // default arabic font
const defaultEn = "'Poppins', sans-serif"; // defautl english font

const useRTL = (locale,providedEnglishFont) => {
  const { t, i18n } = useTranslation(locale);
  const isRTL = i18n.translator.language === 'ar' ? true : false;
  
  const fontFamily = i18n.translator.language === 'ar' ? defaultAr : providedEnglishFont ? providedEnglishFont : defaultEn;

  return [t, isRTL, fontFamily];
};

export default useRTL;
